import type { MobileConfig } from '../'

export const defaultAppConfig: MobileConfig = {
  update: false,
  links: {
    linkTelegram: 'https://t.me/kartoy',
    linkVk: 'https://vk.ru/kartoy',
    linkDzen: 'https://dzen.ru/kartoy',
    linkYoutube: 'https://www.youtube.com/@kartoy',
    linkInstagram: 'https://www.instagram.com/kartoy',
    linkX: 'https://x.com/kartoy',
    linkBluesky: 'https://bsky.app/profile/kartoy.bsky.social',

    linkTerms: 'https://kartoy.example.com/terms-of-use/ru',
    linkPolicy: 'https://kartoy.example.com/privacy-policy/ru',
    linkAML: 'https://kartoy.example.com/aml/ru',

    linkStoreIos: 'https://apps.apple.com/app/kartoy/id000000000',
    linkStoreAndroid: 'https://play.google.com/store/apps/details?id=com.kartoy.app',

    linkRateAppIos: 'https://apps.apple.com/app/kartoy/id000000000?action=write-review',
    linkRateAppAndroid: 'https://play.google.com/store/apps/details?id=com.kartoy.app',

    linkFaq: 'https://kartoy.example.com/faq',
    // Инструкция по привязке карты к Apple Pay / Google Pay. Пока статьи нет — ведём в общий FAQ
    linkCardWalletGuide: 'https://teletype.in/@kartoy/qt_AayvDl25',
    linkSupport: 'https://t.me/yakarta_support_bot',

    linkReferral: 'https://t.me/kartoy_bot/app?startapp=ref_',
    linkReferralConditions: 'https://kartoy.example.com/ref-program',

    linkSdk: 'https://github.com/kartoy/sdk',
    linkExampleApp: 'https://github.com/kartoy/example-app',
  },
  ratingPopup: {
    frequencyHours: 240,
    snoozeDays: 180,
    isEnabled: false,
  },
}
